import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from '@radix-ui/react-id';
import classNames from 'classnames';
import { Flex } from '../../layout/Flex.mjs';
import { useLinearLocale } from '../../locale/LocaleContext.mjs';
import { Switch } from '../../switch/Switch.mjs';
import { Typography } from '../../typography/Typography.mjs';
import { useDatePickerContext } from '../context/datePickerContext.mjs';
import { modeToggleSwitch } from '../datePicker.vanilla.mjs';
import { localeValues } from './localeValues.mjs';
import ModeToggleTrigger from './ModeToggleTrigger.mjs';

const MODE_TOGGLE_SWITCH_NAME = "ModeToggleSwitch";
const ModeToggleSwitch = ({
  __scopeDatePicker,
  switchProps,
  className,
  ...props
}) => {
  const { locale } = useLinearLocale();
  const { mode } = useDatePickerContext(
    MODE_TOGGLE_SWITCH_NAME,
    __scopeDatePicker
  );
  const switchId = useId();
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      align: "center",
      justify: "between",
      className: classNames(modeToggleSwitch, className),
      ...props,
      children: [
        /* @__PURE__ */ jsx(Typography, { asChild: true, weight: 600, color: "grayDark", children: /* @__PURE__ */ jsx("label", { htmlFor: switchId, children: localeValues[locale].modeToggleSwitchLabel }) }),
        /* @__PURE__ */ jsx(ModeToggleTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
          Switch,
          {
            id: switchId,
            size: "small",
            ...switchProps,
            checked: mode === "range"
          }
        ) })
      ]
    }
  );
};

export { ModeToggleSwitch as default };
//# sourceMappingURL=ModeToggleSwitch.mjs.map
